import { ICONS } from "../icons.map";

export enum SERVICE {
  UNDIFINED = 9999,
  EXCHANGE365 = 111,
  ONEDRIVE = 141,
  TEAMS = 151,
  GMAIL = 211,
  GOOGLEDRIVE = 241,
  GCHAT = 242,
  LOCALDISK = 321,
  NETWORKDRIVE = 331,
  DROPBOX = 441,
  SHAREPOINT = 333,
}

export const ServiceHelper = {
  asKey(str: string | number): string {
    switch (str) {
      case SERVICE.GMAIL:
      case "gmail":
        return "gmail";
      case "gchat":
        return "gchat";
      case SERVICE.GOOGLEDRIVE:
      case "gdrive":
        return "gdrive";
      case SERVICE.EXCHANGE365:
      case "Exchange":
      case "exchange":
      case "exchange_365":
        return "exchange_365";
      case SERVICE.ONEDRIVE:
      case "OneDrive":
      case "onedrive":
        return "onedrive";
      case SERVICE.TEAMS:
      case "Teams":
      case "ms_teams":
      case "teams":
        return "ms_teams";
      case SERVICE.SHAREPOINT:
      case "SharePoint":
      case "share_point":
      case "sharepoint":
        return "sharepoint";
      case SERVICE.DROPBOX:
      case "DropBox":
        return "dropbox";
      default:
        return "dropbox";
    }
  },
  asColor(type: SERVICE | string): string {
    switch (type) {
      case SERVICE.EXCHANGE365:
      case "Exchange":
      case "exchange":
      case "exchange_365":
        return " --exchange";
      case SERVICE.ONEDRIVE:
      case "OneDrive":
      case "onedrive":
        return "--onedrive";
      case "gmail":
      case SERVICE.GMAIL:
        return "--gmail";
      case "gchat":
        return "--gchat";
      case SERVICE.TEAMS:
      case "Teams":
      case "ms_teams":
        return "--teams";

      case SERVICE.SHAREPOINT:
      case "SharePoint":
      case "sharepoint":
      case "share_point":
        return "--sharepoint";

      case SERVICE.DROPBOX:
      case "DropBox":
        return "--dropbox";
      default:
        return "";
    }
  },
  asArray() {
    return [
      SERVICE.EXCHANGE365,
      SERVICE.ONEDRIVE,
      SERVICE.TEAMS,
      SERVICE.SHAREPOINT,
    ];
  },
  as_dropdown_array() {
    return ServiceHelper.asArray().map((id) => {
      return {
        id: ServiceHelper.asKey(id),
        name: ServiceHelper.asString(id),
        // @ts-ignore
        icon: ICONS.SERVICE.byNumber(id),
        checked: false,
      };
    });
  },
  as_dropdown_item(source: string) {
    return {
      id: ServiceHelper.asKey(source),
      name: ServiceHelper.asString(source),
      // @ts-ignore
      icon: ICONS.SERVICE.byString(source),
      checked: false,
    };
  },
  asStringArray() {
    return ServiceHelper.asArray().map((s) => ServiceHelper.asString(s));
  },
  asString(type: SERVICE | string): string {
    switch (type) {
      case SERVICE.EXCHANGE365:
      case "exchange":
      case "exchange_365":
        return "Exchange";
      case "gchat":
        return "Gchat";
      case SERVICE.ONEDRIVE:
      case "onedrive":
        return "OneDrive";
      case SERVICE.TEAMS:
      case "teams":
      case "ms_teams":
        return "Teams";
      case SERVICE.GMAIL:
      case "gmail":
        return "Gmail";
      case SERVICE.GOOGLEDRIVE:
      case "gdrive":
        return "Drive";
      case SERVICE.LOCALDISK:
        return "Local Disk";
      case SERVICE.NETWORKDRIVE:
        return "Network Drive";
      case SERVICE.DROPBOX:
      case "dropbox":
        return "DropBox";
      case SERVICE.SHAREPOINT:
      case "sharepoint":
      case "share_point":
        return "SharePoint";
      default:
        return "Unknown Service";
    }
  },
};
